import { ChatBotMessage } from '@insta-club/models';

interface Props {
    message: ChatBotMessage;
}

const UserChatBubble: React.FC<Props> = ({ message }) => {
    return (
        <div className='bg-primary-50 flex self-start py-2 px-4 rounded-t-2xl rounded-bl-2xl max-w-xs'>
            <div
                className='text-sm leading-loose text-gray-600'
                dangerouslySetInnerHTML={{
                    __html: message.content
                }}
            />
        </div>
    );
};

export default UserChatBubble;

